// removed by extract-text-webpack-plugin
module.exports = {"installmentsTitle":"_3A9A7"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/Installments/Installments.scss
// module id = 191
// module chunks = 0 1